// API
import { tmxApiCall } from './index'

export default {
  async createLead (firstName, middleName, lastName, cellPhoneNumber, email, deviceType, zipCode, state) {
    return tmxApiCall('post', '/leadTracking', {
      firstName,
      middleName,
      lastName,
      cellPhoneNumber,
      email,
      deviceType,
      zipCode,
      state
    })
  },

  async cancelLead (leadId) {
    return tmxApiCall('put', '/leadTracking', {
      leadId
    })
  },

  async saveLeadEvent (leadId, applicationId, eventName, customerName, email, phone, status, ftaApproved, appointmentTime, appointmentStoreNumber, appointmentStoreName, approvedAmount) {
    return tmxApiCall('post', '/leadEvent', {
      leadId,
      applicationId,
      eventName,
      status,
      customerName,
      email,
      phone,
      ftaApproved,
      appointmentTime,
      appointmentStoreNumber,
      appointmentStoreName,
      approvedAmount
    })
  }
}
